export default import.meta.ROLLDOWN_FILE_URL_vfvOHDzCvCvWBc6b9K0Pew